import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import TaskCreateForm from "./TaskCreateForm";
import "./CreateTaskPage.css";

const DEV_OR_DA_ROLES = new Set(["developer", "data-analyst"]);

// Phase 2A common task creation page. Standalone route wrapper around the
// SAME TaskCreateForm the Complaints/My Tickets modals now also use (see
// TaskCreateModal.jsx) -- no duplicate business logic. This route stays
// fully functional as a fallback/deep-link URL:
//   /<role>/tasks/create            (this component, mode=undefined)
//   /<role>/tasks/raise-complaint   (this component, mode="complaint")
// Existing IT-ticket-specific pages/forms are untouched.
export default function CreateTaskPage({ mode }) {
  const { user } = useContext(AuthContext);
  const isStaff = user?.role === "staff";
  const isDevOrDA = DEV_OR_DA_ROLES.has(user?.role);
  const isComplaintMode = isStaff || mode === "complaint";

  return (
    <div className="unit-page createtask-page-theme">

      <div className="unit-header">
        <div>
          <div className="unit-page-label">{isComplaintMode ? "Complaints" : isDevOrDA ? "Tickets" : "Tasks"}</div>
          <h2>{isComplaintMode ? "Raise Complaint" : isDevOrDA ? "Create Ticket" : "Create Task"}</h2>
          <p>
            {isComplaintMode
              ? "Describe your complaint below. It will be reviewed and assigned to a technician."
              : isDevOrDA
                ? "Record your own development, testing, documentation, data-analysis or other configured work — not an IT support complaint."
                : "Create a general, development, testing, documentation or other configured task type."}
          </p>
        </div>
      </div>

      <TaskCreateForm mode={mode} />
    </div>
  );
}
